/**
 * Envío UI-3 · marca del proyecto abierto (la lee el panel Marca y el
 * inspector de texto para "Aplicar estilo de marca"). Sin consultas
 * periódicas: se carga al abrir el panel o al cambiar de proyecto.
 */
import { create } from 'zustand';
import { brandService } from '../services/brandService';

export const useBrandStore = create((set, get) => ({
  projectId: null,
  brand: null,        // {id, name, handle, logo_asset_id, fields}
  logoUrl: null,
  brands: null,       // lista de mis marcas (resumen)
  loading: false,
  error: null,

  async load(projectId, { force = false } = {}) {
    if (!projectId) { set({ projectId: null, brand: null, logoUrl: null }); return; }
    if (!force && get().projectId === projectId && (get().brand || get().loading)) return;
    set({ projectId, loading: true, error: null });
    try {
      const out = await brandService.forProject(projectId);
      if (get().projectId !== projectId) return;
      set({ brand: out.brand || null, logoUrl: out.card?.logo_url || null, loading: false });
    } catch (err) {
      if (get().projectId !== projectId) return;
      set({ brand: null, logoUrl: null, loading: false, error: 'No se pudo cargar la marca' });
    }
  },

  async loadList() {
    try { set({ brands: await brandService.list() }); } catch { set({ brands: [] }); }
  },

  async assign(projectId, ref) {
    const out = await brandService.assign(projectId, ref);
    set({ brand: out.brand || null, logoUrl: out.card?.logo_url || null, projectId });
    return out;
  },

  async create(projectId, name) {
    const out = await brandService.create({ name });
    await get().assign(projectId, out.brand.id);
    get().loadList();
    return out;
  },

  async update(patch) {
    const b = get().brand;
    if (!b) return null;
    const out = await brandService.update(b.id, patch);
    set({ brand: out.brand || b, logoUrl: out.card?.logo_url ?? get().logoUrl });
    return out;
  },

  // Envío LMX-4c · deshacer el último cambio de la marca (migración 046).
  async undo() {
    const b = get().brand;
    if (!b) return null;
    const out = await brandService.undo(b.id);
    set({ brand: out.brand || b, logoUrl: out.card?.logo_url ?? get().logoUrl });
    return out;
  },

  reset() { set({ projectId: null, brand: null, logoUrl: null, brands: null, error: null }); },
}));

export default useBrandStore;
